import styled from '@mui/material/styles/styled'
import MuiPagination from '@mui/material/Pagination'

export const Pagination = styled(MuiPagination, {
  name: 'Pagination',
  slot: 'Root',
  skipSx: true,
  skipVariantsResolver: true,
})(({ theme }) => {
  const m = theme.spacing(1.6)

  return {
    marginLeft: 'auto',
    margin: `${m} ${m} ${m} auto`,
  }
})
